import styled from 'styled-components'
import { colors } from 'client/styles'

export const PayNowBase = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-block: 0 20px;
  padding-inline: 20px;
  background: ${colors.white};
`

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-block-end: 20px;
`

export const Title = styled.div`
  font-weight: 700;
  font-size: 21px;
  line-height: 27.3px;
  color: ${colors.grey1};
  padding-block-end: 16px;
`

export const Text = styled.div`
  display: flex;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  color: ${colors.grey2};
`

export const PendingToPay = styled(Text)`
  display: flex;
  justify-content: space-between;
  font-weight: 700;
  width: 100%;
  color: ${colors.grey1};
  padding-block-end: 20px;
`

export const PendingToPayText = styled(PendingToPay)`
  & > div {
    font-weight: normal;
  }
`

export const ChangeCreditCardLink = styled.a`
  color: ${colors.grey1};
  cursor: pointer;
  display: flex;
  font-size: 14px;
  line-height: 20px;
  text-decoration: underline;

  &:active,
  &:hover {
    color: ${colors.grey1};
  }

  &:focus {
    outline: 0;
  }
`

export const ButtonWrapper = styled(Row)`
  padding-block-end: 10px;
`
